module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n        <dt>\n            <label for=\'integration_configuration_name\'>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_configuration_name\' name=\'integration_configuration[name]\' value="' +
((__t = ( name )) == null ? '' : __t) +
'">\n        </dd>\n        <dt>\n            <label for=\'integration_configuration_url\'>URL</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_configuration_url\' name=\'integration_configuration[url]\' value="' +
((__t = ( url )) == null ? '' : __t) +
'">\n        </dd>\n        <dt>\n            <label for=\'integration_configuration_api_key\'>' +
((__t = ( i18next.t('glossary.api_key') )) == null ? '' : __t) +
'</label>\n        </dt>\n        <dd>\n            <input class=\'text\' id=\'integration_configuration_api_key\' name=\'integration_configuration[api_key]\' value="" placeholder="' +
((__t = ( i18next.t('ui.field_will_update') )) == null ? '' : __t) +
'">\n        </dd>\n    </dl>\n</form>\n';

}
return __p
}